export const MORE_ACCESSORIES_TEST_ID = {
  heading: 'heading',
};
